module.exports = global["$"] = require("-!.\\jquery.js");